import React, { useState } from 'react'
import type { ProductType } from '@/types'
import TabStripExperiment from './TabStripExperiment'
import { PRODUCT_TABS_EXPERIMENT } from '../SearchForm/constants'
import getProductCategory from './utils/getProductCategory'

export default function SearchFormExperimentWrapper({
  currentTab,
  onFormChange
}: {
  currentTab: ProductType
  onFormChange: (productType: ProductType) => void
}) {
  const [formState, setFormState] = useState(getProductCategory(currentTab))
  const handleOnTabClick = (productType: ProductType) => {
    if (productType === currentTab) {
      return
    }
    const selectedProductCategory = getProductCategory(productType)
    setFormState(selectedProductCategory)
    onFormChange(productType)
  }
  return (
    <div className="w-auto">
      <div className="mx-auto p-4 max-w-7xl flex flex-col justify-center gap-4">
        <TabStripExperiment
          initialActiveTab={currentTab}
          onTabClick={handleOnTabClick}
          productTabs={PRODUCT_TABS_EXPERIMENT}
        />
        <div className="w-full max-w-7xl bg-primary-1 md:p-4 md:rounded-xl md:shadow-lg">
          {formState.component}
        </div>
      </div>
    </div>
  )
}
